export default "__VITE_ASSET__5da70ffe__"